import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "country-cl", class: _vm.$x.nsAddressForm },
    [
      _c(VTextField, {
        staticClass: "flex-column",
        attrs: {
          name: "address1",
          maxlength: "40",
          required: "",
          "validate-on-blur": "",
          label: _vm.t.address1Label,
          rules: _vm.address1Rules,
        },
        on: { blur: _vm.onBlur, input: _vm.addressUpdated },
        model: {
          value: _vm.address.address1,
          callback: function ($$v) {
            _vm.$set(_vm.address, "address1", $$v)
          },
          expression: "address.address1",
        },
      }),
      _vm._v(" "),
      _c(VTextField, {
        staticClass: "flex-column",
        attrs: {
          name: "address2",
          maxlength: "34",
          "validate-on-blur": "",
          "aria-label": _vm.t.address2Label,
          rules: _vm.address2Rules,
        },
        on: { blur: _vm.onBlur, input: _vm.addressUpdated },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.t.address2Label) +
                    "\n            "
                ),
                _c("span", { class: _vm.$x.optional }, [
                  _vm._v(" " + _vm._s(_vm.t.optional) + " "),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.address.address2,
          callback: function ($$v) {
            _vm.$set(_vm.address, "address2", $$v)
          },
          expression: "address.address2",
        },
      }),
      _vm._v(" "),
      _c(VTextField, {
        staticClass: "flex-column",
        attrs: {
          name: "city",
          maxlength: "25",
          required: "",
          "validate-on-blur": "",
          label: _vm.t.cityLabel,
          rules: _vm.cityRules,
        },
        on: { blur: _vm.onBlur, input: _vm.addressUpdated },
        model: {
          value: _vm.address.city,
          callback: function ($$v) {
            _vm.$set(_vm.address, "city", $$v)
          },
          expression: "address.city",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$x.dualColumn },
        [
          _c("NsSelect", {
            staticClass: "flex-column",
            class: _vm.$x.firstCol,
            attrs: {
              items: _vm.districts,
              name: "district",
              label: _vm.t.districtLabel,
              rules: _vm.stateRules,
            },
            on: { blur: _vm.onBlur, input: _vm.addressUpdated },
            model: {
              value: _vm.address.district,
              callback: function ($$v) {
                _vm.$set(_vm.address, "district", $$v)
              },
              expression: "address.district",
            },
          }),
          _vm._v(" "),
          _c("NsSelect", {
            attrs: {
              items: _vm.regions,
              name: "region",
              label: _vm.t.regionLabel,
              rules: _vm.stateRules,
            },
            on: { blur: _vm.onBlur, input: _vm.addressUpdated },
            model: {
              value: _vm.address.region,
              callback: function ($$v) {
                _vm.$set(_vm.address, "region", $$v)
              },
              expression: "address.region",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.includeEmail
        ? _c(VTextField, {
            staticClass: "flex-column",
            attrs: {
              name: "email",
              maxlength: "50",
              required: "",
              "validate-on-blur": "",
              label: _vm.t.emailLabel,
              rules: _vm.emailRules,
            },
            on: { input: _vm.addressUpdated, blur: _vm.onBlur },
            model: {
              value: _vm.address.email,
              callback: function ($$v) {
                _vm.$set(_vm.address, "email", $$v)
              },
              expression: "address.email",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }